module.exports = __webpack_public_path__ + "assets/images/arrow.725645934d9962fd04ffef018d3a2805.svg";